/**
 * @author Charles Blais
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import Tooltip from '../tooltip';

/** React */
const EventsFormElement = ({
  id,
  label,
  controlProps,
  children,
  feedback,
  isInvalid,
  tooltipText
}) => {

  return (
    <FormGroup controlId={id} validationState={isInvalid ? "error" : null}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <ControlLabel style={{ margin: 0 }}>{label}</ControlLabel>
        {tooltipText && (
          <Tooltip text={tooltipText} size="small" />
        )}
      </div>
      <FormControl {...controlProps}>
        {children}
      </FormControl>
      <FormControl.Feedback />
      {feedback && isInvalid ? <HelpBlock>{feedback}</HelpBlock> : null}
    </FormGroup>
  );
};

EventsFormElement.propTypes = {
  /** Controller ID */
  id: PropTypes.string.isRequired,
  /** Label text for the control */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Additional properties to be sent to FormControl element of react-bootstrap v3 */
  controlProps: PropTypes.object.isRequired,
  /** Feedback information on the form element */
  feedback: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** FormControl children information */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  /** Display as invalid controller component (error occurred) */
  isInvalid: PropTypes.bool,
  /** Tooltip text displayed next to the label */
  tooltipText: PropTypes.string, // <-- ADDED THIS
};

EventsFormElement.defaultProps = {
  feedback: null,
  children: null,
  isInvalid: false,
  tooltipText: null,
};

export default EventsFormElement;
